
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { register } from '../api';

const Register = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '', type: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    try {
      await register(form);
      setSuccess(true);
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    }
  };

  return (
    <div className="min-h-screen bg-accent flex items-center justify-center font-official">
      <div className="bg-white rounded-lg shadow p-8 w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4">Register</h1>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <input name="name" type="text" placeholder="Name" className="border p-2 rounded" value={form.name} onChange={handleChange} required />
          <input name="email" type="email" placeholder="Email" className="border p-2 rounded" value={form.email} onChange={handleChange} required />
          <input name="password" type="password" placeholder="Password" className="border p-2 rounded" value={form.password} onChange={handleChange} required />
          <select name="type" className="border p-2 rounded" value={form.type} onChange={handleChange} required>
            <option value="">Select Type</option>
            <option value="talent">Talent</option>
            <option value="company">Company</option>
          </select>
          <button type="submit" className="bg-primary text-secondary px-4 py-2 rounded font-bold hover:bg-yellow-300">Register</button>
        </form>
        {error && <div className="text-red-600 mt-2">{error}</div>}
        {success && <div className="text-green-600 mt-2">Registration successful! Redirecting...</div>}
      </div>
    </div>
  );
};

export default Register;
